import { JoinEfbLandingLogo } from "@/assets/JoinEfbLandingLogo";
import { Button } from "@/components/ui/button";
import { useRouter } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useJoinCircleMutation } from "@/api/circles-api";
import { getLoginURL } from "@/utils/auth";
import { toast } from "react-toastify";
import useUserStore from "@/store/userStore";
import { Circle } from "@/types/circle";
import Show from "@/components/Show";
import { Loader2 } from "lucide-react";
import { ResponsiveJoinEfb } from "@/assets/ResponsiveJoinEfb";

interface EFBCircleProps {
  circle: Circle;
}

const JoinEfb = ({ circle }: Readonly<EFBCircleProps>) => {
  const { t } = useTranslation();
  const { token } = useUserStore();
  const { mutate, isPending } = useJoinCircleMutation();
  const router = useRouter();

  function handleJoin() {
    if (!token) {
      window.location.href = getLoginURL("");
    } else if (circle.is_user_joined) {
      router.navigate({ to: "/donor-profile", search: { page: "circles" } });
    } else {
      mutate(
        { id: circle.id },
        {
          onSuccess: () => {
            toast.success(t("joinCircleModal.success"));
            router.navigate({ to: "/circle/" + circle.id });
          },
          onError: () => {
            toast.error(t("joinCircleModal.failed"));
          },
        },
      );
    }
  }
  return (
    <div
      className="relative flex min-h-[468px] flex-1 flex-col rounded-2xl border border-[#E2DDD7] p-6 md:min-h-[580px]"
      id="joyride-join-efb"
    >
      <h3 className="mb-4 text-2xl font-650 leading-[127%] md:mb-6 md:text-5xl md:leading-[120%]">
        {t("landingPage.coh")}
      </h3>
      <p className="mb-4 text-base font-350 leading-[140%] md:mb-8 md:text-2xl md:leading-8">
        {t("landingPage.cohDescription")}
      </p>
      <Button
        size="lg"
        className="z-50 w-full text-base md:w-fit"
        onClick={handleJoin}
        disabled={isPending}
      >
        <Show when={isPending}>
          <Loader2 className="size-4 animate-spin" />
        </Show>
        <Show when={!circle.is_user_joined} fallback={t("joinCircleModal.viewYourCircles")}>
          {t("landingPage.joinEfb")}
        </Show>
      </Button>
      <JoinEfbLandingLogo />
      <ResponsiveJoinEfb />
    </div>
  );
};

export default JoinEfb;
